import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const HardwareAttendancesService = {
    list: async (filters) => axios.post(API_URL + "/hardware-attendances/list", {filters}).then(({data}) => data).catch(err => { throw err }),

    get: async (id) => axios.get(API_URL + "/hardware-attendances/" + id).then(({data}) => data).catch(err => { throw err }),

    create: async (model) => axios.post(API_URL + "/hardware-attendances", model).then(({data}) => data).catch(err => { throw err }),

    edit: async (model, id) => axios.post(API_URL + "/hardware-attendances/" + id, model).then(({data}) => data).catch(err => { throw err }),

    delete: async (id) => axios.delete(API_URL + "/hardware-attendances/" + id).then(({data}) => data).catch(err => { throw err }),

    getByProject: async (projectId) => axios.get(API_URL + "/hardware-attendances/by-project/" + projectId).then(({data}) => data).catch(err => { throw err }),
};

export default HardwareAttendancesService;